export default () => ({
    streamIsLoading: (state) => {
        return state.stream && state.streamLastEventId === undefined && !state.streamError
    },
})